import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ConfigService } from 'src/app/services/config.service';

export const columns = [
  { key: 'dictType', name: 'DICTIONARY_TYPE', visible: true },
  { key: 'dictKey', name: 'DICTIONARY_KEY', visible: true },
  { key: 'dictValue', name: 'DICTIONARY_VALUE', visible: true },
  { key: 'updateTime', name: 'UPDATE_TIME', visible: true },
  { key: 'createTime', name: 'CREATE_TIME', visible: true },
];

@Component({
  selector: 'app-dictionary',
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.scss']
})
export class DictionaryComponent implements OnInit {

  dataSource: any[] = [];
  columns: any[] = columns;
  widthConfig = ['20%','20%','20%','20%','20%','120px'];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  params = {
    dictType: '',
    dictKey: '',
    dictValue: '',
  };
  
  roleList: any[] = [];
  
  isVisible = false;
  validateModuleForm!: FormGroup;
  isSpinning = false;


  constructor(
    private service: ConfigService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.getList();
    this.validateModuleForm = this.fb.group({
      id: [null, []],
      dictType: [null, [Validators.required]],
      dictKey: [null, [Validators.required]], 
      dictValue: [null, []],
    });
  }

  onSearch() {
    this.pagination.pageIndex = 1;
    this.getList();
  }

  onClear() {
    this.params = {
      dictType: '',
      dictKey: '',
      dictValue: '',
    };
    this.onSearch();
  }
  

  getList() {
    this.isSpinning = true;
    this.service.getTableList({ size: this.pagination.pageSize, current: this.pagination.pageIndex, param: this.params }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { rows, total } = rtnData;
        this.dataSource = rows;
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
  }

  onEdit(row: any) {
    this.isSpinning = true;
    this.service.addOrUpdate(row).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
    this.onCancel();
  }

  onDelete(row: any) {
    this.isSpinning = true;
    this.service.delete(row.id).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onEditUser(row: any) {
    const { dictKey, dictType, dictValue, id } = row;
    this.validateModuleForm.setValue({
      dictKey, dictType, dictValue, id
    });
    this.isVisible = true;
  }

  onSave() {
    if (this.validateModuleForm.valid) {
      this.isVisible = false;
      this.onEdit(this.validateModuleForm.value);
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onCancel() {
    this.validateModuleForm.reset();
    this.isVisible = false;
  }
}
